// 定义一个混入对象
import {mapGetters} from "vuex";
import {doNothing, isMeaningful, isMeaningless, isNotBlank, findComponentDownward} from "@/utils/common";
import {RE} from "@/utils/const";
import {OpEnum} from "@/utils/options";
import {downloadAttFile} from "@/api/common";
import {Message} from 'element-ui';
import { getTaskTenant, reverseTaskStatus } from "@/api/guide";
import { GET_USER_GUIDE_TASK_DATA, SET_USER_GUIDE_TASK_DATA, SET_USER_GUIDE_STATE, SET_USER_GUIDE_TASK_ITEM } from "@/store/mutation-types";

export const userInfoMixIn = {
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    ...mapGetters([
      'userInfo'
    ])
  }
};

export const inputNoticeParentMixIn = {
  created() {
    this.$on('input', function ($event) {
      this.$parent.$emit('input', $event);
    })
  }
};

export const font14MixIn = {
  props: {
    font14: {
      type: Boolean,
      default: false
    }
  }
};

export const tooltipMixin = {
  props: {
    tooltip: {
      type: String,
      default: null
    }
  }
};

export const isMeaningfulMixin = {
  data() {
    return {
      isMeaningful: isMeaningful
    }
  }
};

export const isMeaninglessMixin = {
  data() {
    return {
      isMeaningless: isMeaningless
    }
  }
};

export const formMixin = {
  props: {
    form: {
      required: true
    }
  },
};

export const formValidatorMixin = {
  data() {
    return {
      formValid: false
    }
  },
  methods: {
    formValidate() {
      if (isMeaningful(this.$refs['form'])) {
        this.formValid = !this.$refs['form'].fields.some(e => e.validateState === 'error');
      }
      let _formValid = false;
      this.$refs.form.validate((valid) => {
        _formValid = valid;
      });
      return _formValid;
    },
    // 可扩展参数，返回errMsg，暂只支持返回boolean
    formValidateField(fields) {
      let errMsg = null;
      this.$refs.form.validateField(fields, (errorMessage) => {
        errMsg = errorMessage;
      });
      return isMeaningless(errMsg);
    }
  }
};

export const formDeleteItemMixin = {
  data() {
    return {
      formItemsName: 'items'
    }
  },
  methods: {
    deleteItem(index) {
      this.form[this.formItemsName].splice(index, 1);
    }
  }
};

export const modalMixIn = {
  data() {
    return {
      confirmLoading: false,
      proxyTrueModalVisible: false,
      proxyFalseModalVisible: true
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
  },
  computed: {
    modalVisible: {
      get: function () {
        return (this.visible || this.proxyTrueModalVisible) && this.proxyFalseModalVisible;
      },
      set: function (newVal) {
        this.$emit('update:visible', newVal);
      }
    }
  },
  methods: {
    cancel() {
      this.modalVisible = false;
    },
    confirm() {

    }
  }
};

export const modalMixInDetail = {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
  },
  computed: {
    modalVisibleDetail: {
      get: function () {
        return this.visible;
      },
      set: function (newVal) {
        this.$emit('update:visible', newVal);
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false);
    },
    confirm() {}
  }
};

export const doNothingMixIn = {
  methods: {
    doNothing: doNothing
  }
};

export const selectionMixin = {
  data() {
    return {
      selectedRows: [],
      $gjSelectionListened: false,
    };
  },
  mounted() {
    this.listenSelection();
  },
  computed: {
    noSelect() {
      return !this.hasSelect;
    },
    hasSelect() {
      return isMeaningful(this.selectedRows) && this.selectedRows.length > 0;
    }
  },
  methods: {
    modalOpen() {
      const vm = this;
      this.$nextTick(() => vm.listenSelection());
    },
    // 清除用户选择
    clearCheckboxRow() {
      const gjTableRef = this.$refs['gjTable'];
      if (gjTableRef) {
        gjTableRef.$refs.gjTable.clearCheckboxRow();
        this.selectedRows = [];
      }
    },
    listenSelection() {
      const gjTableRef = this.$refs['gjTable'];
      if (gjTableRef && !this.$gjSelectionListened) {
        gjTableRef.$on('selection-change', (rows) => {
          this.selectedRows = rows;
        });
        this.$gjSelectionListened = true;
      }
    },
    selectedAllIs(prop, value) {
      return this.hasSelect && this.selectedRows.map(e => e[prop]).every(e => e === value);
    },
    selectedAllIsNot(prop, value) {
      return this.hasSelect && this.selectedRows.map(e => e[prop]).every(e => e !== value);
    },
    selectedSomeIs(prop, value) {
      return this.hasSelect && this.selectedRows.map(e => e[prop]).some(e => e === value);
    },
    selectedSomeIsNot(prop, value) {
      return this.hasSelect && this.selectedRows.map(e => e[prop]).some(e => e !== value);
    },
    selectedSomeIn(prop, values) {
      return this.hasSelect && this.selectedRows.map(e => e[prop]).some(e => values.includes(e));
    },
    selectedSomeNotIn(prop, values) {
      return this.hasSelect && this.selectedRows.map(e => e[prop]).some(e => !values.includes(e));
    },
    selectedAllIn(prop, values) {
      return this.hasSelect && this.selectedRows.map(e => e[prop]).every(e => values.includes(e));
    },
    selectedAllNotIn(prop, values) {
      return this.hasSelect && this.selectedRows.map(e => e[prop]).every(e => !values.includes(e));
    },
    eqSelectable(prop, value) {
      return (row) => row[prop] === value;
    },
    notEqSelectable(prop, value) {
      return (row) => row[prop] !== value;
    }
  }
};
export const bakSelectRowsMixin = {
  data(){
     return {
       bakSelectedRows:[]
     }
  },
  methods:{
    clearBakRows(){
      this.bakSelectedRows = [];
    }
  }
}

export const noRepeatQueryMixin = {
  data(){
      return {
         queryBtnLoading:false,
      }
   },
  watch:{
     'params':{
        handler(){
          this.queryBtnLoading = false;
        },
        deep:true
     },
    'filter':{
      handler(){
        this.queryBtnLoading = false;
        this.queryLoading = false;
      },
      deep:true
    },
  }
}
export const queryMixin = {
  async created() {
    if (isMeaningful(this.defaultSort)) {
      this.sort = this.defaultSort;
    }
    this.$gjQueryInit();
    this.$on('query', this._.debounce(() => {
      if (this.$gjQuery) {
        this.$gjQuery();
      }
      // 手动指定回调查询函数
      this.$emit('manual-query', )
    }, 200));
  },
  mounted() {
    this.isExitViewComplent = findComponentDownward(this, 'view-setting')
    // 设置分页参数
    this.pagination.pageSize = this.getCachePagesSize()
    if (this.cacheOptions.useCache) {
      this.$gjMergeCacheToFilter()
    } else {
      // 没有使用缓存，且不存在视图组件的情况， 直接回调
      if (!this.isExitViewComplent && !this.isDisableInitHttp) {
        this.$emit('query')
      }
    }
  },
  data() {
    return {
      loading: false,
      globalParams: null,
      isInitParams: true,
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      sort: {
        order: 'descending',
        prop: "id"
      },
      // 缓存配置项
      cacheOptions: {
        // 公共mixin是否缓存表单数据，默认不缓存，如果需要在组件手动缓存， 可以指定为false
        useCache: false,
        // 缓存的key,可以不指定， 默认将当前路由路径设置为key
        key: '',
        // 缓存的一级表单名字
        filterKey: 'filter',

      },
      // 是否使用了缓存
      isUseCache: false,
      REF_VIEW_SETTING: 'viewSetting',
      isManualEmit: false,
      // 是否在mixin里禁用初始请求
      isDisableInitHttp: false,
      // 是否存在视图组件
      isExitViewComplent: null,
    //  在存在视图组件的情况下是否获取试图缓存数据
      isAttemptCache: true
    }
  },
  computed: {
    queryPagination() {
      return {
        current: this.pagination.currentPage,
        size: this.getCachePagesSize()
      }
    },
    querySort() {
      return {
        order: this.sort.order,
        sort: this.sort.prop
      }
    },
    CACHE_PARAMS ({ filterKey = 'filter' }) {
      return {
        ...this[filterKey]
      }
    }
  },
  watch: {
    'pagination.pageSize': {
      handler() {
        // 不管有无设置缓存， 都缓存分页
        this.setCachePages()
      },
      immediate: false
    }
  },
  methods: {
    // 查找视图组件
    findViewComponent (context) {
      const childrens = context.$children;
      let children = null;

      if (childrens.length) {
        for (const child of childrens) {
          const name = child.$options.name;

          if (name === 'view-setting') {
            children = child;
            break;
          } else {
            children = this.findViewComponent(child);
            if (children) break;
          }
        }
      }
      return children;
    },
    // 视图第一次加载完回调函数
    async handCompleteView(res) {
      // commentId 是用来判断是否是从消息中心跳转到review和feedback
        // 如果界面没有使用表单数据
        if (!this.isUseCache) {
          if (res && this.isAttemptCache) {
            let params = JSON.parse(res.params)
            params = await this.generateViewParams(params)
            this.mergeRemoteParams(params)
            this.$emit('query')
          } else {
            if(this.isAttemptCache){
              this.$gjQueryInit()
            }
            this.$emit('query')
          }
        }
        this.customHandView && this.customHandView()
    },
    /**
     * 切换视图
     */
    async handleChangeView (view) {
      if (view && view.params) {
        try {
          let params = JSON.parse(view.params)
          params = await this.generateViewParams(params)
          if (params && this.mergeRemoteParams && typeof this.mergeRemoteParams === 'function') {
            this.$gjQueryInit()
            this.mergeRemoteParams(params)
          }
          this.$emit('query')
        } catch (e) {
          console.warn(e)
        }
      } else {
        this.$gjQueryInit()
        this.$emit('query')
      }
    },
    /**
     * 设置全局查询参数
     */
    mergeRemoteParams (params) {
      let date
      if (params.date) {
        date = params.date
      } else {
        if (params.startDateTime && params.endDateTime) {
          date = { key: params.dateType, value: [params.startDateTime, params.endDateTime]}
        } else {
          date = this[this.cacheOptions.filterKey].date
        }
      }
      // const date = params.date ? params.date : (params.startDateTime && params.endDateTime ? { key: params.dateType, value: [params.startDateTime, params.endDateTime]} : this.filter.date)
      this[this.cacheOptions.filterKey] = Object.assign({}, this[this.cacheOptions.filterKey], {
        ...params,
        date
      })
    },

    getCachePagesSize() {
      const s = this.getCacheData('$cachePages') || {}
      if (s.pageSize) {
        return s.pageSize
      }

      return this.pagination.pageSize
    },
     /**
     * 在页面不存在视图组件的情况下
     * @param filterKey 配置业务模块具体查询key值
     * @returns {Promise<null|*>}
     */
      $gjMergeCacheToFilter () {
        const s = this.getCacheData() || {}
        if (s.query && JSON.stringify(s.query) !== '{}') {
          this.isUseCache = true
          this.mergeRemoteParams(s.query)
        }
        // 如果缓存里有值或者不存在视图组件，则直接回调
        if (this.isUseCache || !this.isExitViewComplent) {
          this.$emit('query')
        }
      },

    /**
     * 清空缓存
     */
    async $gjCacheReset () {
      await this.$cacheQuery.removeCache({key: this.cacheOptions.key})
    },
    $gjQueryInit(type) {
      if(this.$gjQueryResetParams && this.isInitParams && type === 'reset') {
        const params = this.$gjQueryResetParams();
        for (let key in params) {
          this[key] = params[key];
        }
      } else if (this.$gjQueryInitParams && this.isInitParams) {
        const params = this.$gjQueryInitParams();
        for (let key in params) {
          this[key] = params[key];
        }
      }
      if (!this.isInitParams) {
        this.isInitParams = true;
      }
    },
    $gjNoticeQuery(type) {
      this.$gjHasNoticeQuery = true;
      if (isMeaningless(type)) {
        this.pagination.currentPage = 1;
      }
      // 设置启用缓存，在每次查询之前缓存一次
      if (this.cacheOptions.useCache && type !== 'reset') {
        this.setCacheData(type)
      }
      if (type !== 'reset') {
        this.customCacheCallback && this.customCacheCallback()
      }

      this.$emit('query');
    },
    async $gjReset() {
       this.$gjQueryInit('reset');
       this.$gjCacheReset()
       this.pagination.pageSize = 20
       this.$gjNoticeQuery('reset');
    },
    $gjResetPage() {
      this.pagination.currentPage = 1;
      this.$gjNoticeQuery();
    },
    getPagination(queryResponse) {
      return {
        currentPage: queryResponse.current,
        pageSize: queryResponse.size,
        total: queryResponse.total,
      };
    },
    // 需要处理缓存时
    $gjSortChangeCatch({column, property, order}) {
      if (order) {
        this.sort.prop = (column.sortBy || property || '').replace(/(slot:)|(option(\(.*\))?:)/, '');
        this.sort.order = `${order}ending`;
      } else {
        this.sort.prop = 'default';
        this.sort.order = 'default';
      }
      this.$gjNoticeQuery();
    },
    $gjSortChange({column, property, order}) {
      if (order) {
        this.sort.prop = (column.sortBy || property || '').replace(/(slot:)|(option(\(.*\))?:)/, '');
        this.sort.order = `${order}ending`;
      } else {
        this.sort.prop = null;
        this.sort.order = null;
      }
      this.$gjNoticeQuery();
    },

    // 设置分页
    setCachePages() {
      this.$cachePages.setCache({key: this.cacheOptions.key, params: this.pagination})
      // // 为了兼容有的在组件里单独设置和获取参数及分页缓存的逻辑， 在对有缓存的进行分页数据更新处理
      // this.$cacheQuery.updateCache(this.cacheOptions.key, {
      //   pagination: this.pagination
      // })
    },
    // 设置缓存
    setCacheData() {
      if (!this.$gjCacheCallback) return

      const params = {}
      params['query'] = this.$gjCacheCallback(this[this.cacheOptions.filterKey] || {})
      params.pagination = this.pagination
      this.$cacheQuery.setCache({params, key: this.cacheOptions.key})
    },

    getCacheData(type = '$cacheQuery') {
      return this[type].getCache({key: this.cacheOptions.key})
    }
  }
};

export const formRuleMixin= {
  data() {
    return {
      RE: RE
    }
  },
  methods: {
    $gjRequired(message, trigger = ['blur', 'change'], required = true) {
      return { required, message, trigger };
    },
    $gjMinRule(number, errMsg) {
      return this.$gjCustomRule((value) => {
        if (isMeaningless(value)) return true;
        return Number(value) >= number;
      }, errMsg);
    },
    $gjMaxRule(number, errMsg) {
      return this.$gjCustomRule((value) => {
        if (isMeaningless(value)) return true;
        return Number(value) <= number;
      }, errMsg);
    },
    $gjReRule(re, errMsg, match = true, trigger = ['blur', 'change']) {
      return {
        validator: (rule, value, callback) => {
          if (isMeaningless(value)) callback();
          const reMatch = re.test(value);
          if (isMeaningful(value) && reMatch !== match) {
            callback(new Error(errMsg));
          } else {
            callback();
          }
        },
        trigger,
      }
    },
    $gjCustomRule(validator, errMsg, trigger = ['blur', 'change']) {
      return {
        validator: (rule, value, callback) => {
          const result = validator(value);
          if (isMeaningless(result)) {
            callback();
          } else if (typeof result === 'string') {
            callback(new Error(result));
          } else if (typeof result === 'boolean') {
            if (result) {
              callback();
            } else {
              callback(new Error(errMsg));
            }
          } else {
            callback();
          }
        },
        trigger,
      }
    },
    $gjFormValidate() {
      let formValid = false;
      this.$refs.form.validate((valid) => {
        formValid = valid;
      });
      return formValid;
    }
  }
};

export const valueCheckMixin = {
  methods: {
    someIs(value, option) {
      return option.some(item => item === value);
    },
    noneIs(value, option) {
      return option.every(item => item !== value);
    }
  }
};

export const opTypeMixin = {
  props: {
    opType: {
      type: Number,
      default: OpEnum.type.ADD
    },
  },
  data() {
    return {
      OpEnum: OpEnum
    }
  },
  computed: {
    viewOpType() {
      return this.opType === OpEnum.type.VIEW;
    },
    addOpType() {
      return this.opType === OpEnum.type.ADD;
    },
    editOpType() {
      return this.opType === OpEnum.type.UPDATE;
    },
  }
};

export const stepsMixin = {
  props: {
    cancel: {
      type: Function
    },
    previousStep: {
      type: Function
    },
    nextStep: {
      type: Function
    }
  },
};

export const uploadMixin = {
  data() {
    return {
      importHandleLoading: false,
      importHandleLoadingText: '数据解析中...',
    }
  },
  methods: {
    $gjImportHandle(res, uploadCb) {
      // gj-upload组件的回调，用于组件和父组件之间数据通信
      uploadCb && uploadCb(res)
      // emit导入文件成功事件
      this.$emit('importFileSuccess', successList);
      let successList = [];
      if (res.data && res.data.successList) {
        successList = res.data.successList;
      }
      // data 错误附件id
      if (isMeaningful(res.data) && isMeaningful(res.data.fileId)) {
        // 错误时的处理
        //uploadText 在调用gj-upload的父组件中定义，用于在返回的报文提示后面，加提示文案（目前只有在成本中心导入中使用）
        if(this.uploadText){
          this.$gjMessage.error(res.msg+'，'+this.uploadText);
        }else {
          this.$gjMessage.error(res.msg);
        }

        if (successList && successList.length > 0) {
          this.$emit('importPartSuccess', successList);
        }
        // 错误文件弹窗下载方法
        // this.$gjDownloadErrorFile(res.data.fileId);
      } else {
        if(this.uploadText){
          this.$gjMessage.success(res.msg+'，'+this.uploadText);
        }else {
          this.$gjMessage.success(res.msg)
        }
        this.$emit('importSuccess', successList);
        this.$gjDestroy();
      }
    },
    $gjDownloadErrorFile(errorFileId) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          content: '检测到导入文件有错误，是否下载错误文件?'
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            downloadAttFile(errorFileId);
            modal.$gjDestroy();
            this.$gjDestroy();
          }
        }
      })
    }
  }
};

export const responseMixin = {
  methods: {
    $gjResponseHandle(res, successFn, errorFn) {
      if (res.isError) {
        if (errorFn) {
          errorFn();
        } else {
          this.$gjMessage.error(res.msg || '网络错误');
        }
      } else {
        successFn();
      }
    }
  }
};

export const permissionChangeMixin = {
  computed: {
    ...mapGetters(['userResources'])
  },
  watch: {
    userResources: {
      handler: function (userResources) {
        this.$emit('$permissionChange', userResources);
      },
      immediate: true
    }
  }
};

export const keepAliveMixin = {
  computed: {
    ...mapGetters(['keepAliveViews'])
  },
};

export const kefuMixin = {
  mounted() {
    this.relateUs();
  },
  methods: {
    relateUs() {
      const _script = document.createElement("script");
      const headTag = document.getElementsByTagName('head')[0];
      _script.type = "text/javascript";
      _script.src = this.kefuLink;
      _script.charset = "utf-8";
      headTag.appendChild(_script);
    }
  }
};

export const dashboardMixin = {
  computed:{
    // dashboard全局数据  dashboardCurrency:选中的币种  timezoneText:选中时区的时间  timezoneId:选中时区的ID  marketAuthType:用户店铺授权、广告授权状态 countryMarket: 选中站点与店铺数据
    ...mapGetters(['dashboardCurrency', 'timezoneText', 'timezoneId','marketAuthType','countryMarket']),
    //用于控制跟店铺授权挂钩的板块 是否显示蒙板和调用数据接口
    showStoreMask:function (){
      let marketAuth = this.marketAuthType.find(r=> r.authType==='market');
      if(marketAuth){
        return marketAuth.auth
      }else {
        return false
      }
    },
    //用于控制跟广告授权挂钩的板块 是否显示蒙板和调用数据接口
    showAdMask:function (){
      let marketAuth = this.marketAuthType.find(r=> r.authType==='ads');
      if(marketAuth){
        return marketAuth.auth
      }else {
        return false
      }
    },
    filter() {
      return {
        dateTime: this.timezoneText,
        currency: this.dashboardCurrency,
        countryMarket:this.countryMarket
      }
    }
  },
  watch: {
    // 选中时区变化 或选中币种变化时，重新请求数据
    filter: {
      handler: function() {
        this.$gjNoticeQuery()
      }
    }
  },
}

// 用户指引混入
export const userGuideMixin = {
  data() {
    return {
      userGuideTaskRouter: {
        SHOP_MANAGE_001: { title: '店铺授权', router: '/system/market', permission: 'market:view'},
        SHOP_MANAGE_002: { title: '广告授权', router: '/system/market', permission: 'market:view' },
        SHOP_MANAGE_003: { title: '邮箱授权', router: '/system/market', permission: 'market:view' },
        ACCOUNT_MANAGE_001: { title: '用户管理', router: '/setting/user', permission: 'user:view' },
        PRODUCT_MANAGE_001: { title: '产品资料', router: '/product/product-manager', permission: 'product:view' },
        PRODUCT_MANAGE_002: { title: 'listing关联产品', router: '/sale/listing', permission: 'listing:view' },
        BASE_DATA_001: { title: '供应商管理', router: '/purchase/supplier-manager', permission: 'supplier:view' },
        BASE_DATA_002: { title: '供应商报价', router: '/purchase/supplier-manager', permission: 'supplier:view' },
        BASE_DATA_003: { title: '仓库管理', router: '/warehouse/warehouse-information', permission: 'warehouse:view' },
        BASE_DATA_004: { title: '头程物流', router: '/logistics/head-logistics', permission: 'transport:view' },
        BASE_DATA_005: { title: '物流商管理', router: '/logistics/logistics-provider', permission: 'logistics:view' },
        COST_ACCOUNTING_001: { title: '成本维护', router: '/finance/cost-center', permission: 'financialMonthCost:view' },
        COST_ACCOUNTING_002: { title: '成本计算方式', router: '/setting/argument?activeTab=financeCost', permission: 'storageCostBatch:view' },
        PLUGIN_INSTALL_001: { title: '插件安装', router: '/tool/cloud-plugin-status', permission: 'pluginOnlineStatus:view' }
      },
      list: [
        {
          taskTypeCode: "SHOP_MANAGE",
          status: "2",
          title: "店铺管理",
          gpoint1: "",
          gpoint2: "",
          time: "01:28",
          btn: "去授权",
          videoUrlCode: 'MARKET',
          itemArray: [
            {
              taskTypeCode: "SHOP_MANAGE",
              taskChildCode: "SHOP_MANAGE_001",
              status: "0",
              title: "店铺授权",
              type: "未开始",
              content: "店铺授权为使用系统的第一步，授权完成后可以在系统查看listing、销售订单、Review、Feedback等信息，系统还可以为您生成统计分析报表，辅助您分析销售数据",
              videoUrlCode: 'MARKET',
            },
            {
              taskTypeCode: "SHOP_MANAGE",
              taskChildCode: "SHOP_MANAGE_002",
              status: "0",
              title: "广告授权",
              type: "待开启",
              condition: "完成店铺授权后可开启此任务",
              content: "广告授权完成后，您可以在系统管理您的广告投放，同时，系统也会自动同步亚马逊的广告数据，为您提供广告数据分析",
              videoUrlCode: 'MARKET',
            },
            {
              taskTypeCode: "SHOP_MANAGE",
              taskChildCode: "SHOP_MANAGE_003",
              status: "0",
              title: "邮箱授权",
              type: "待开启",
              condition: "完成店铺授权后可开启此任务",
              content: "邮箱授权完成后，您可以在系统回复买家消息",
              videoUrlCode: 'MARKET',
            },
          ],
        },
        {
          taskTypeCode: "ACCOUNT_MANAGE",
          status: "2",
          title: "账号管理",
          gpoint1: "",
          gpoint2: "",
          time: "02:26",
          btn: "去管理",
          videoUrlCode: 'USER',
          itemArray: [
            {
              taskTypeCode: "ACCOUNT_MANAGE",
              taskChildCode: "ACCOUNT_MANAGE_001",
              status: "0",
              title: "用户管理",
              type: "已完成",
              content: "您不是一个人在战斗，给您的团队成员添加系统账号，让小伙伴们一起加入吧~",
              videoUrlCode: 'USER',
            },
          ],
        },
        {
          taskTypeCode: "PRODUCT_MANAGE",
          status: "2",
          title: "产品管理",
          gpoint1: "已获取10积点",
          gpoint2: "完成任务可获取10积点",
          time: "05:27",
          btn: "去管理",
          videoUrlCode: 'PRODUCT',
          itemArray: [
            {
              taskTypeCode: "PRODUCT_MANAGE",
              taskChildCode: "PRODUCT_MANAGE_001",
              status: "0",
              title: "产品资料",
              type: "已完成",
              content: "产品管理为卖家管理自己内部产品与组合产品，通过产品表现与采购进行关联，更好进行管理",
              videoUrlCode: 'PRODUCT',
            },
            {
              taskTypeCode: "PRODUCT_MANAGE",
              taskChildCode: "PRODUCT_MANAGE_002",
              status: "0",
              title: "listing关联产品",
              type: "进行中",
              condition: "完成店铺授权、产品资料维护且系统同步到listing后可开启此任务",
              content: "将listing与内部产品进行关联，数据展示与分析更多维度户。（注：亚马逊与后台产品打通，销售环节与供应商环节联动，为后续自动化运营提供支撑）",
              videoUrlCode: 'PRODUCT',
            },
          ],
        },
        {
          taskTypeCode: "BASE_DATA",
          status: "2",
          title: "基础资料",
          gpoint1: "",
          gpoint2: "",
          time: "06:10",
          btn: "去完善",
          videoUrlCode: 'SUPPLIER',
          itemArray: [
            {
              taskTypeCode: "BASE_DATA",
              taskChildCode: "BASE_DATA_001",
              status: "0",
              title: "供应商管理",
              type: "已完成",
              content: "维护供应商资料，与内部产品关联，可直接创建采购单。（注：维护好供应商和供应产品资料，为采购选择最合适的供货供应商）",
              videoUrlCode: 'SUPPLIER',
            },
            {
              taskTypeCode: "BASE_DATA",
              taskChildCode: "BASE_DATA_002",
              status: "0",
              title: "供应商报价",
              type: "进行中",
              condition: "完成供应商管理、产品资料维护后可开启此任务",
              content: "维护供应商报价信息，在下采购订单时才可以选择更合适的供应商",
              videoUrlCode: 'SUPPLIER',
            },
            {
              taskTypeCode: "BASE_DATA",
              taskChildCode: "BASE_DATA_003",
              status: "0",
              title: "仓库管理",
              type: "未开启",
              content: "维护仓库资料，与供应商、产品打通，对供应链端采购、发货、调货一键管理",
              videoUrlCode: 'WAREHOUSE',
            },
            {
              taskTypeCode: "BASE_DATA",
              taskChildCode: "BASE_DATA_004",
              status: "0",
              title: "头程物流",
              type: "未开启",
              content: "维护不同的物流方式以及时效",
              videoUrlCode: 'LOGISTICS',
            },
            {
              taskTypeCode: "BASE_DATA",
              taskChildCode: "BASE_DATA_005",
              status: "0",
              title: "物流商管理",
              type: "未开启",
              content: "创建物流商资料：维护物流商信息，发货、调拨、装配流程不用愁",
              videoUrlCode: 'LOGISTICS',
            },
          ],
        },
        {
          taskTypeCode: "COST_ACCOUNTING",
          status: "2",
          title: "成本核算",
          gpoint1: "",
          gpoint2: "",
          time: "03:22",
          btn: "去维护",
          videoUrlCode: 'COST',
          itemArray: [
            {
              taskTypeCode: "COST_ACCOUNTING",
              taskChildCode: "COST_ACCOUNTING_001",
              status: "0",
              title: "成本维护",
              type: "已完成",
              condition: "完成店铺授权且系统同步到listing后可开启此任务",
              content: "管理产品采购成本与到库成本，快速了解店铺财务数据与实际经营状况。（注：完成产品数据，维护产品成本，采购、发货时即可了解调取成本数据，快速一览）",
              videoUrlCode: 'COST',
            },
            {
              taskTypeCode: "COST_ACCOUNTING",
              taskChildCode: "COST_ACCOUNTING_002",
              status: "0",
              title: "成本计算方式",
              type: "进行中",
              content: "选择一种适合您企业的成本计算方式，让您的利润核算更加精准",
              videoUrlCode: 'COST',
            },
          ],
        },
        {
          taskTypeCode: "PLUGIN_INSTALL",
          status: "2",
          title: "插件安装",
          gpoint1: "",
          gpoint2: "",
          time: "02:58",
          btn: "去安装",
          videoUrlCode: 'PLUGIN',
          itemArray: [
            {
              taskTypeCode: "PLUGIN_INSTALL",
              taskChildCode: "PLUGIN_INSTALL_001",
              status: "0",
              title: "插件安装",
              type: "已完成",
              content: "安装插件后，系统将可以自动获取流量与日期范围报告的数据，您可在系统结合销售与流量数据同步分析，让您的运营策略更合理；您也可以在系统查看财务维度的利润报表，让您的成本核算、提成计算更精准",
              videoUrlCode: 'PLUGIN',
            },
          ],
        },
      ],

    }
  },
  computed: {
    ...mapGetters(['userGuideState', 'userGuideTaskData', 'userGuideTaskItem', 'keepAliveViews', 'navMenuTabs',])

  },
  methods: {
    // 下一步
    userGuideNextStep(step = null) {
      if(this.userGuideState && this.$refs['newUserGuide']) {
        this.$refs['newUserGuide'].nextStep(step)
      }
    },
    // 不展示指引弹框, 不退出指引模式
    userGuideTemporarilyClosed() {
      if(this.userGuideState && this.$refs['newUserGuide']) {
        this.$refs['newUserGuide'].temporarilyClosed()
      }
    },
    // 关闭退出引导模式
    userGuideCancel() {
      if(this.userGuideState && this.$refs['newUserGuide']) {
        this.$refs['newUserGuide'].cancel()
      }
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },

    async fetchAsyncTaskList(){
      const data =  await getTaskTenant()
      this.$store.commit(SET_USER_GUIDE_TASK_DATA, data);
      return data;
    },

    jumpToGuidePage(taskItem, callBack){

      let taskTitle = taskItem.title;
      let taskChildCode = taskItem.taskChildCode;
      let status = taskItem.status || taskItem.taskStatus;

      let msg;
      let routerData;
      let router;
      // status = 0;
      if (status == 3 || status === 'AWAIT_TURN_ON'){
        msg = `${taskTitle}任务未开启，请先开启任务~`;
        Message({ message: msg,  type: 'warning', duration: 3 * 1000 });
        callBack(taskItem)
        return
      }
      
      routerData = this.userGuideTaskRouter[taskChildCode]
      if (!routerData){
        msg = "未找到任务页面~";
        Message({ message: msg,  type: 'error', duration: 3 * 1000 });
        return
      }

      if (this.$permission(routerData.permission)) {
        router = routerData.router;
      }else{
        msg = "您无权访问任务页面，请联系管理员授权~";
      }

      if (router){
        if (status != 1 && status !== 'COMPLETED'){
          this.changeTaskStatus(taskChildCode);
        }
        this.$store.commit(SET_USER_GUIDE_TASK_ITEM, taskItem);

        this.$store.commit(SET_USER_GUIDE_STATE, true);

        // 判断跳转任务页面是否已经打开
        let findIndex = this.navMenuTabs.findIndex(item => item.path == router )
        if (findIndex == -1) { // 未打开直接跳转
          this.$router.push({ path: router })
        } else { // 刷新已打开页面
          // 移除组件缓存
          const keepAliveIndex = this.keepAliveViews.findIndex(
            (e) => e === this.navMenuTabs[findIndex].componentName
          );
          keepAliveIndex > -1 && this.keepAliveViews.splice(keepAliveIndex, 1);
          this.$router.push({
            path: "/redirect",
            query: {
              url: router,
            },
          });
        }
        // this.$router.push({ name: router, params: taskItem })
        if(callBack){
          callBack(taskItem);
        }
      }else if (msg){
        Message({ message: msg,  type: 'error', duration: 3 * 1000 });
      }
    },

    changeTaskStatus(taskChildCode){
      let param = {
        taskChildCode: taskChildCode,
        tenantCodeList: []
      }
      reverseTaskStatus(param).then(data => {
        this.$store.dispatch(GET_USER_GUIDE_TASK_DATA);
      }).catch(error => {
      })
    },

    jumpNextTask(taskTypeCode, taskChildCode, callBack){
      //获取目标task
      let targetTask = this.getNextTask(taskTypeCode, taskChildCode)
      if (targetTask){
        this.jumpToGuidePage(targetTask, callBack);
      }else {
        //当前子任务列表全部完成
        Message({ message: '当前所有任务已完成',  type: 'error', duration: 3 * 1000 });
      }
    },

    /**
     *
     * @param {*} taskTypeCode
     * @param {*} taskChildCode
     * @param {是否跳过本次任务状态的检测 } skip
     * @returns
     */
     async getNextTask(taskTypeCode, taskChildCode, skip = false) {
      await this.$store.dispatch(GET_USER_GUIDE_TASK_DATA);

      const userGuideTaskData = this.userGuideTaskData;
      const taskList = userGuideTaskData?.taskList
      if(taskList == null || taskList.length == 0){
        return {}
      }

      //目标任务类型列表
      let itemTypeList = this.list.find(item =>{
        return item.taskTypeCode ===  taskTypeCode
      });

      // if (!itemTypeList){
      //   // itemTypeList = this.list[0]
      //   return null
      // }

      let itemSortArray = itemTypeList?.itemArray || []
      let nextTask;

      let finishTaskList = true;
      let nextIndex;
      for (let i = 0; i < itemSortArray.length; i++) {
        const item = itemSortArray[i];
        if (taskChildCode === item.taskChildCode && !skip) { // 跳过本次任务状态的检测
          nextIndex = i + 1;
          continue;
        }
        const statueData = taskList.find(e => {
          return e.taskChildCode === item.taskChildCode
        })
        if (statueData.taskStatus !== 'COMPLETED') {
          finishTaskList = false;
        }
        if (i == nextIndex) {
          nextTask = statueData;
          nextTask.videoUrlCode = item.videoUrlCode
        }
      }
      if(!finishTaskList && nextTask && nextTask.taskStatus == 'COMPLETED' && nextIndex < itemSortArray.length - 1) {
        for (let i = nextIndex + 1; i < itemSortArray.length; i++) {
          const item = itemSortArray[i];
          const statueData = taskList.find(e => {
            return e.taskChildCode === item.taskChildCode
          })
          if (statueData.taskStatus !== 'COMPLETED') {
            nextTask = statueData
            break
          }
        }
      }
      return { finishTaskList, nextTask }
    },

    /**
     * -1  未知状态  不该出现
     * 0  未完成
     * 1 已完成大类
     * @param {*} taskTypeCode
     * @param {*} taskChildCode
     * @returns
     */
    completeAllTaskStatus(taskTypeCode, taskChildCode){
      if (!taskTypeCode || !taskChildCode) {
        return -1
      }
      const userGuideTaskData = this.userGuideTaskData;
      const taskList = userGuideTaskData?.taskList
      if(taskList == null || taskList.length == 0){
        return -1
      }
      //任务状态列表
      const filterTaskList = taskList.filter(item => {
        return item.taskTypeCode == taskTypeCode
      })
      let finishAll = 0;
      filterTaskList.forEach(item => {
        if ( item.taskChildCode !== taskChildCode &&  item.taskStatus !== 'COMPLETED') {
          finishAll = 1;
        }
      });
      return finishAll;
    },
    isWaitTurnOn(taskStatus){
      return taskStatus === 'AWAIT_TURN_ON'
    },
    message(msg){
      Message({ message: msg,  type: 'error', duration: 3 * 1000 });
    },
    getVideoUrl(code){
      return window.location.origin + '/guide-video?code=' + code
    },
    //获取积点
    getTaskInfo(taskTypeCode){
      const userGuideTaskData = this.userGuideTaskData;
      const taskTypeList = userGuideTaskData?.taskTypeList;
      if(taskTypeList == null || taskTypeList.length == 0){
        return 0
      }
      const taskIndex = taskTypeList.findIndex((item,index) => {
        return item.taskTypeCode == taskTypeCode
      })
      let task
      if(taskIndex > -1) {
        task = taskTypeList[taskIndex]
      }
      return { index:taskIndex + 1, task}
    }
  }
}


